export default function Stats() {
  const statsData = [
    { value: '¥30亿+', label: '累计为用户创造收益', icon: 'ri-money-cny-circle-line' },
    { value: '50万+', label: '注册用户数', icon: 'ri-user-star-line' },
    { value: '99.7%', label: '策略执行成功率', icon: 'ri-check-double-line' },
    { value: '500+', label: 'AI策略模型', icon: 'ri-cpu-line' },
  ];

  return (
    <section className="py-16 md:py-20 bg-primary-500">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {statsData.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 rounded-2xl bg-background-50/20">
                <i className={`${stat.icon} text-2xl text-background-50`}></i>
              </div>
              <div className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-2">
                {stat.value}
              </div>
              <div className="text-sm text-background-50/70">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}